/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { Autocomplete, Grid, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, COPY_CAMPAIGN_SUCCESS_MESSAGE, DELETE_CAMPAIGN, DELETE_CAMPAIGN_SUCCESS_MESSAGE, ACTIVATE_CAMPAIGN_SUCCESS_MESSAGE, DEACTIVATE_CAMPAIGN_SUCCESS_MESSAGE, COPY_CAMPAIGN, ACTIVATE_TEST_MODE, DEACTIVATE_TEST_MODE, UNKNOWN_ERR } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { BrandApiResponse1, BrandListPropType, RootState, appConfigs } from '../types/types';
import { FormControl } from '@mui/material';
import { changeStatusCampaign, copyCampaign, deleteCampaign, getAllCampaigns, getCampaignReportData, updateCampaignTestMode } from 'src/services/campaignService';
import CsvService from 'src/services/dataExport.service';
import { Link, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { getAllBrand } from 'src/services/brandService';
import { getAllGroup } from 'src/services/groupService';
import APIInformation from './APIInformation';
import SendTestEmail from '../SendTestEmail/SendTestEmail';
// import MainLayout from '../Layouts/Mainlayout';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import { MultiplicationSignStrokeStandard } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
import type { TooltipProps } from '@mui/material/Tooltip';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TemplatePreview from '../TemplatePreview/TemplatePreview'; // Import your modal component
//@ts-ignore
import { ViewStrokeRounded, Image03Icon } from '@hugeicons-pro/core-stroke-rounded';
import * as EmailValidator from 'email-validator';
import {checkEventPermission} from "../../common/utility/utility";
const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} placement="bottom" />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
    },
}));

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const ITEM_HEIGHT = 48;

interface ApiResponse {
    status: number;
    data: {
        data: any[];
        result: number;
    };
}

interface GroupListPropType {
    "id": number;
    "clientId": number;
    "clientName": string;
    "groupName": string;
    "isDeleted": boolean;
    "createdBy": number;
    "createdByUserName": string;
    "createdOn": string;
    "modifiedBy": number;
    "modifiedOn": string;
    "modifiedByUserName": string;
}

interface GroupApiResponse {
    status: number;
    data: {
        data: GroupListPropType[];
        result: number;
    };
}

function CampaignList(): JSX.Element {
    const [campaignListData, setCampaignListData] = useState<any[]>([])
    const [campaignSearchData, setCampaignSearchData] = useState<any[]>([])
    const [openAddTemplateModal, setOpenAddTemplateModal] = useState<boolean>(false)
    const [openEditTemplateModal, setOpenEditTemplateModal] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
    const [templateInfoData, setTemplateInfoData] = useState<any>();
    const [showDeleteTemplateModal, setDeleteTemplateModal] = useState<boolean>(false);
    const [showDeactivateTemplateModal, setDeactivateTemplateModal] = useState<boolean>(false);
    const [showCopyCampaignModal, setCopyCampaignModal] = useState<boolean>(false);
    const [templateId, setTemplateId] = useState<number>(0)
    const [selectedValue, setSelectedValue] = useState<any>({ value: "", label: "Select Status" })

    const [brands, setBrands] = useState<any>([])
    const [groups, setGroups] = useState<any>([])
    const [campaignId, setCampaignId] = useState<number>(0)
    const [openAPIInformationModal, setOpenAPIInfoModal] = useState<boolean>(false)
    const [searchText, setSearchText] = useState("");
    const [selectedBrand, setSelectedBrand] = useState<any>(null);
    const [selectedGroup, setSelectedGroup] = useState<any>(null);
    const [selectedStatus, setSelectedStatus] = useState<{ value: string; label: string } | null>(null);
    const [testEmailModalOpen, setTestEmailModalOpen] = useState(false);
    const [isCampaignInUse, setisCampaignInUse] = useState(false);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');

    const [showActivateTestModal, setActivateTestModal] = useState<boolean>(false);
    const [isTestMode, setIsTestMode] = useState<boolean>(false);
    const [emails, setEmails] = useState<string>('');
    const [error, setError] = useState<string>('');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const storedAppConfig = localStorage.getItem("appConfigs");

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"));
    // const RoleId = userData.roleID;

    useEffect(() => {
        const ClientId = user?.clientId ?? 0;
        getAllBrand(ClientId)
            .then(
                (res: BrandApiResponse1) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const brandArr: BrandApiResponse1[] = [];
                            res.data.data.map((brand: any) => {
                                brand.Name = `${brand.clientName}`
                                brandArr.push(brand)
                            })
                            setBrands(brandArr)
                        } else {
                            setBrands([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )


        getAllGroup(ClientId)
            .then(
                (res: GroupApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            const webhookArr: GroupListPropType[] = [];
                            res.data.data.map((webhook: any) => {
                                webhook.Name = `${webhook.clientName}`
                                webhookArr.push(webhook)
                            })
                            setGroups(webhookArr)
                        } else {
                            setGroups([])
                        }
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        getCampaignListData()
    }, [user])

    const getCampaignListData = (): void => {
        setLoading(true)
        const ClientId = user?.clientId ?? 0;
        getAllCampaigns(ClientId)
            .then(
                (res: ApiResponse) => {
                    console.log("CampaignList", res)
                    if (res.status === 200) {
                        const templateArr: any[] = [];
                        res.data.data.map((template: any) => {
                            template.Name = `${template.templateName}`
                            templateArr.push(template)
                        })
                        setCampaignListData(templateArr)
                        setCampaignSearchData(templateArr)
                    }
                }
            )
            .catch(
                (error: any) => console.log("Error: ", error)
            )
            .finally(() => {
                setLoading(false)
            })
    }

    const handleAddCampaignClick = (): void => {
        navigate('/campaigns/new-campaign')
    }

    const handleCloseAddTemplateModal = (): void => {
        setOpenAddTemplateModal(false)
    }

    const handleEditTemplateClick = (id: number): void => {
        setTemplateId(id);
        setOpenEditTemplateModal(true)
    }

    const handleCloseEditTemplateModal = (): void => {
        setOpenEditTemplateModal(false)
    }

    const handleRefreshPage = (): void => {
        getCampaignListData()
        handleCloseAddTemplateModal()
        handleCloseEditTemplateModal()
        handleCloseAPIInfoModal()
    }

    const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
        // anchorActionEl[id] = event.currentTarget
        setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
    }

    const applyFilters = (): void => {
        let filteredData = [...campaignListData]; // Always start from original data

        // Search filter
        if (searchText.trim() !== "") {
            filteredData = filteredData.filter((template) =>
                template.name.toLowerCase().includes(searchText.toLowerCase())
            );
        }

        // Brand filter
        if (selectedBrand) {
            filteredData = filteredData.filter((template) => template.brandId === selectedBrand.id);
        }

        // Group filter
        if (selectedGroup) {
            filteredData = filteredData.filter((template) => template.groupId === selectedGroup.id);
        }

        // Status Filter
        if (selectedStatus) {
            if (selectedStatus.value === "active") {
                filteredData = filteredData.filter(
                    (template) => template.isTestMode !== true && template.isActive === true
                );
            } else if (selectedStatus.value === "inactive") {
                filteredData = filteredData.filter(
                    (template) => template.isTestMode !== true && template.isActive === false
                );
            } else if (selectedStatus.value === "test") {
                filteredData = filteredData.filter(
                    (template) => template.isTestMode === true
                );
            }
        }

        setCampaignSearchData(filteredData);
    };

    // Update search text and apply filters
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
        setSearchText(e.target.value);
    };

    // Update brand filter and apply filters
    const handleSearchByBrand = (brand: string): void => {
        setSelectedBrand(brand);
    };

    // Update group filter and apply filters
    const handleSearchByGroup = (group: string): void => {
        setSelectedGroup(group);
    };


    // Handle Status Selection
    const handleTemplateValue = (newValue: { value: string; label: string } | null): void => {
        setSelectedStatus(newValue);
    };

    // Run `applyFilters` whenever search, brand, or group changes
    useEffect(() => {
        applyFilters();
    }, [searchText, selectedBrand, selectedGroup, selectedStatus]);


    const handleDeleteTemplate = (id: number, templateName: string, isCampaignInUse: boolean): void => {
        setTemplateInfoData({ id, templateName });
        setDeleteTemplateModal(true)
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setisCampaignInUse(isCampaignInUse);
    }

    const handleDeleteTemplateClose = (): void => {
        setDeleteTemplateModal(false);
        setisCampaignInUse(false);

    }

    const handleDeleteTemplateConfirm = (): void => {
        setIsModalSaveLoading(true)

        const { id } = templateInfoData;

        const data = {
            "campaignId": id,
            "isDeleted": true,
            "deletedBy": userData.id,
        }

        deleteCampaign(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            NotificationManager.success(DELETE_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            setDeleteTemplateModal(false)
                            getCampaignListData()
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false));
        setisCampaignInUse(false);
    }

    const handleActivateTestModeModal = (id: number, templateName: string, isTestMode: boolean): void => {
        setTemplateInfoData({ id, templateName });
        setActivateTestModal(true);
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setIsTestMode(isTestMode)
    }

    const closeActivateTestModeModal = (): void => {
        setActivateTestModal(false);
        setIsTestMode(false);
        setEmails('')
    }

    const validateEmails = (emailString: string): string => {
        if (emailString.trim() === '') return 'Please enter email address';
      
        const invalidEmails = !EmailValidator.validate(emailString);
      
        if (invalidEmails) {
          return `Invalid email format`;
        }
      
        return '';
      };

    const handleActivateTestModeConfirm = (): void => {
        if(isTestMode === false) {
            const validationError = validateEmails(emails);
            if (validationError !== "") {
            setError(validationError);
            return;
            }
        }
        

        setIsModalSaveLoading(true)
        const data = {
            "campaignId": templateInfoData.id,
            "isTestMode": isTestMode === true ? false : true,
            "testEmailRecipient": emails,
            "updatedBy": user?.id
        }
        updateCampaignTestMode(data).then((res: any) => {
            if (res.status === 200) {
                if (res.data.result === 1) {
                    setActivateTestModal(false)
                    setEmails('')
                    NotificationManager.success(isTestMode ? "Test mode deactivated successfully" : "Test mode activated successfully", '', 5000);
                    getCampaignListData()
                } else {
                    NotificationManager.error(res.data.message, '', 5000);
                }
            }
        })
        .catch((error: any) => {
            console.log("Error", error)
            NotificationManager.error(UNKNOWN_ERR, '', 5000);
        })
        .finally(() => setIsModalSaveLoading(false))
    }

    const handleupdatestatus = (id: number, statusId: boolean, templateName: string, isCampaignInUse: boolean): void => {
        setTemplateInfoData({ id: id, newStatus: statusId, templateName: templateName });

        // Trigger the modal and close any open action menus
        setDeactivateTemplateModal(true);
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setisCampaignInUse(isCampaignInUse);
    };

    const handleupdatestatusClose = (): void => {
        setDeactivateTemplateModal(false);
        setisCampaignInUse(false);
    }

    const handleUpdateStatusConfirm = (): void => {

        setIsModalSaveLoading(true)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"))
        const { id, newStatus } = templateInfoData;
        const data = {
            "campaignId": id,
            "isActive": newStatus === true ? false : true,
            "updatedBy": userData.id,
        }

        changeStatusCampaign(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            if (newStatus == false) {
                                NotificationManager.success(ACTIVATE_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            } else {
                                NotificationManager.success(DEACTIVATE_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                                // Adjust the width inline
                                setTimeout(() => {
                                    const notification = document.querySelector('.notification-container') as HTMLElement | null;
                                    if (notification !== null) {
                                        notification.style.width = '340px'; // Set your desired width
                                    }
                                }, 0);
                            }
                            setDeactivateTemplateModal(false)
                            getCampaignListData()
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false))
    }

    const handleCopyCampaign = (id: number, templateName: string): void => {
        setTemplateInfoData({ id, templateName });
        setCopyCampaignModal(true)
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }

    const handleCopyCampaignClose = (): void => {
        setCopyCampaignModal(false)
    }

    const handleCopyCampaignConfirm = (): void => {
        setIsModalSaveLoading(true)

        const { id } = templateInfoData;
        const data = {
            "campaignId": id,
            "updatedBy": userData.id,
        }
        copyCampaign(data)
            .then(
                (res: ApiResponse) => {
                    if (res.status === 200) {
                        if (res.data.result === 1) {
                            NotificationManager.success(COPY_CAMPAIGN_SUCCESS_MESSAGE, '', 5000);
                            setCopyCampaignModal(false)
                            getCampaignListData()
                        }
                    }
                }
            )
            .catch((error: any) => console.log("Error", error))
            .finally(() => setIsModalSaveLoading(false))
    }

    const handleAPIInfo = (id: number): void => {
        setCampaignId(id);
        setOpenAPIInfoModal(true)
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }

    const handleCloseAPIInfoModal = (): void => {
        setOpenAPIInfoModal(false)
    }

    const handleDownloadReport = (id: any): void => {
        getCampaignReportData(id)
            .then((res: any) => {
                if (res.status === 200) {
                    console.log(res)
                    if (res.data.result === 1) {
                        const reportData = res.data.data;

                        const data: any = [];
                        if (reportData.length > 0) {

                            reportData.map((item: any) => {
                                const newItem = {
                                    "Campaign Id": item.campaignId,
                                    "Event Id": item.eventId,
                                    "Event Type": item.eventType,
                                    "Event Time": moment(item.eventTime).format("MM-DD-YYYY hh:mm:ss") ,
                                    "Event Data": item.eventData,
                                    "NPI": item.npi,
                                    "Template Id": item.templateId,
                                    "From Name": item.fromName,
                                    "Brand": item.brand,
                                    "Request Id": item.requestId,
                                }

                                data.push(newItem)
                            })
                      
                            const csvData = CsvService.jsonToCsv(data);
                            CsvService.downloadCsvFile(csvData, 'CampaignReport.csv');
                        } else {
                            NotificationManager.error('No data available for download', '', 5000);
                        }
                    } else {
                        NotificationManager.error('No data available for download', '', 5000);
                    }
                }
            })

    }

    // Dropdown options
    const options = [
        { value: 'active', label: 'Active' },          // Use '10' as the identifier for all data
        { value: 'inactive', label: 'InActive' },
        { value: 'test', label: 'Test' },
    ];
    console.log(campaignSearchData);
    const handleEditNavigation = (id: number): void => {
        navigate(`/campaigns/edit-campaign/${id}`);
    }

    const handleViewReport = (id: number, start: any, end: any, campaignName: string, brandName: string, groupName: string): void => {
        navigate(`/campaigns/view-report/${id}`, {
            state: { start, end, campaignName, brandName, groupName},
        });
    };

    const columns: TableColumn<any>[] = [
        {
            name: 'Template',
            cell: (row: any) => {
                let imageUrl: string | null = null;

                if (storedAppConfig != null) {
                    try {
                        const parsedAppConfig = JSON.parse(storedAppConfig) as appConfigs[];
                        const TemplateImagePublicURL = parsedAppConfig.find(
                            (item) => item.configName === "TemplateImagePublicURL"
                        )?.configValue;
                        if (TemplateImagePublicURL != '') {
                            imageUrl = `${TemplateImagePublicURL}Template/${row.templateIdentifier}/Template_Short.png`;
                            console.log(imageUrl)
                        }
                    } catch (error) {
                        console.error("Error parsing appConfig data:", error);
                    }
                }

                console.log("TTemplateRow", row, imageUrl)

                const handlePreview = (): void => {
                    if (row.templateContent) {
                        setPreviewContent(row.templateContent);
                        setIsPreviewModalOpen(true);
                    }
                };

                return (
                    <div className="relative w-[90px] h-[90px] flex items-center justify-center cursor-pointer" onClick={handlePreview}>
                        {(imageUrl != null) ? (
                            <img
                                src={imageUrl}
                                width={90}
                                height={90}
                                alt="Template"
                                className="icon-hover"
                                onLoad={(e) => {
                                    // Ensure the image is displayed when successfully loaded
                                    e.currentTarget.style.display = 'block';
                                }}
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none'; // Hide broken image
                                    const iconElement = e.currentTarget.nextElementSibling as HTMLElement;
                                    if (iconElement) iconElement.style.display = 'flex'; // Show fallback icon
                                }}
                                style={{ borderRadius: '8px', objectFit: 'cover' }}
                            />
                        ) : null}
                        <HugeiconsIcon
                            icon={Image03Icon}
                            size={24}
                            color="#6B7280"
                            className="hidden" // Initially hidden, shown if image fails
                        />
                        <div className={`absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 rounded-lg ${row.templateContent !== "" ? 'hover:opacity-100 transition-opacity cursor-pointer' : ''}`}>
                            <HugeiconsIcon
                                icon={ViewStrokeRounded}
                                size={24}
                                color="white"
                                strokeWidth={0.5}
                                className={`cursor-pointer ${(row.templateContent === "") ? 'opacity-50 cursor-not-allowed' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation(); // Prevents double triggering of handlePreview
                                    handlePreview();
                                }}
                            />
                        </div>
                    </div>
                );
            },
            width: '150px%',
            sortable: false
        },
        {
            name: 'Campaign',
            selector: (row: any) => row.name,
            cell: (row: any) => {
                const hasCampaignStarted = row.startOn && new Date(row.startOn) <= new Date(); // Check if startDate is in the past or today
                const startDate = moment(row.startOn).format('MM/DD/YYYY');
                const endDate = moment(row.endOn).format('MM/DD/YYYY');
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p
                                className="text-14 text-muted font-semibold underline leading-[22px]"
                                onClick={() => handleEditNavigation(row.campaignId)}
                                style={{
                                    cursor: 'pointer',
                                    opacity: 1,
                                }}

                            >
                                {row.name}
                            </p>
                            <p className="text-14 text-muted"><span className='font-semibold'>ID:</span>{row.campaignId}</p>
                            {(hasCampaignStarted && checkEventPermission('CAMPAIGN_VIEW_REPORT')) && (
                                <div className="badge truncate" style={{
                                    background: '#FFF5F6',
                                    padding: '10px 15px',
                                    color: '#F13139',
                                    border: '0px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    marginTop: '10px'
                                }}
                                onClick={() => handleViewReport(row.campaignId, startDate, endDate, row.name, row.brandName, row.groupName)}>View Report</div>
                            )}
                        </div>
                    </div>
                )
            },
            width: '200px',
            sortable: true
        },
        {
            name: 'Duration',
            selector: (row: any) => row.startOn,
            width: '200px',
            //   sortable: true,
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            {row.startOn && row.endOn && (
                                <>
                                    <p className="text-14 text-muted">
                                        <span className='font-semibold'>Start: </span>{moment(row.startOn).format('L')}
                                    </p>
                                    <p className="text-14 text-muted">
                                        <span className='font-semibold'>End: </span>{moment(row.endOn).format('L')}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                )
            },
        },
        {
            name: 'Brand / Group',
            // selector: (row: any) => row.startOn,
            width: '200px',
            //   sortable: true,
            cell: (row: any) => {
                const groupName = groups.filter((group: any) => group.id === row.groupId);
                const brandName = brands.filter((brand: any) => brand.id === row.brandId);
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            {row?.brandName && (
                                <p className="text-14 text-muted"><span className='font-semibold'>Brand: </span>{row.brandName}</p>
                            )}
                            {row?.groupName && (
                                <p className="text-14 text-muted"><span className='font-semibold'>Group: </span>{row.groupName}</p>
                            )}
                        </div>
                    </div>
                )
            },
        },
        {
            name: 'Status',
            selector: (row: any) => row.isActive,
            cell: (row: any) => {
              if (row.isTestMode === true) {
                return (
                    <div className="badge truncate" style={{ background: '#FFF2C2', padding: '10px 15px', color: '#FF7A00', border: '0px', }}>Test</div>
                );
              }
              return row.isActive === true ? (
                <div className="badge truncate" style={{ background: '#CCFFEA', padding: '10px 15px', color: '#06A864', border: '0px'}}>Active</div>
              ) : (
                <div className="badge truncate" style={{ background: '#FFF5F6', padding: '10px 15px', color: '#F13139', border: '0px'}}>Inactive</div>
              );
            }
        },
        {
            name: 'Sent',
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.sent}</span></p>
                        </div>
                    </div>
                )
            },
            //   width: '10%',
            sortable: false
        },
        {
            name: 'Opens',
            sortable: false,
            //   width: "15%",
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.open}</span></p>
                            <p className="text-14 text-muted">{row.openRate}%</p>
                        </div>
                    </div>
                )
            },
        },
        {
            name: 'Clicks',
            // selector: (row: any) => row.fromName,
            // width: '15%',
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.clicks}</span></p>
                            <p className="text-14 text-muted">{row.clickRate}%</p>
                        </div>
                    </div>
                )
            },
            // sortable: true
        },
        {
            name: 'Unsubscribed',
            // selector: (row: any) => row.fromName,
            // width: '15%',
            // sortable: true
            cell: (row: any) => {
                return (
                    <div className="flex py-4 first:pt-0 last:pb-0 text-center" style={{ width: '100%' }}>
                        <div className="overflow-hidden" style={{ width: '100%' }}>
                            <p className="text-14 text-muted"><span className='font-semibold'>{row.unSubscribe}</span></p>
                            <p className="text-14 text-muted">{row.unsubscribeRate}%</p>
                        </div>
                    </div>
                )
            },
        },
        {
            name: 'Actions',
            cell: (row: any) => {
                console.log("anchorActionEl", anchorActionEl)
                return (
                    <div className='flex items-center'>
                        <div className="icon-hover-container">
                            <Link to={{ pathname: `/campaigns/edit-campaign/${row.campaignId}` }} state={{ campaigndata: row }} style={{ width: '20px' }}>
                                {/* <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="Edit Campaign" className="icon-hover" /> */}
                                <HugeiconsIcon
                                icon={PencilEdit02Icon}
                                size={20}
                                color="#3A3A3A"
                                strokeWidth={0.2}
                                />
                            </Link>
                        </div>

                        <div className='flex'>
                            <IconButton
                                aria-label="more"
                                id="long-button"
                                // aria-controls={open ? 'long-menu' : undefined}
                                // aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={(e) => handleActionClick(e, row.campaignId)}
                            >
                                <HugeiconsIcon
                                    icon={MoreVerticalSolidRounded}
                                    size={20}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                />
                            </IconButton>
                            <Menu
                                id={`${row.campaignId}`}
                                className='table-action-menu'
                                MenuListProps={{
                                    'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorActionEl[row.campaignId]}
                                open={Boolean(anchorActionEl[row.campaignId])}
                                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.campaignId]: null })}
                                PaperProps={{
                                    style: {
                                        maxHeight: ITEM_HEIGHT * 4.5,
                                        width: '19ch',
                                    },
                                }}
                            >
                        {checkEventPermission('CAMPAIGN_ACTIVATE') && 
                                <>
                                    {row.isActive === true && (
                                        <MenuItem onClick={() => handleupdatestatus(row.campaignId, row.isActive, row.name, row.isCampaignInUse)}>
                                            <span  className="text-muted font-normal">Deactivate</span>
                                        </MenuItem>
                                    )}

                                    {row.isActive === false && (
                                        <MenuItem onClick={() => handleupdatestatus(row.campaignId, row.isActive, row.name, row.isCampaignInUse)}>
                                            <span  className="text-muted font-normal">Activate</span>
                                        </MenuItem>
                                    )}

                                </>
                                 
                                }
                                 {checkEventPermission('CAMPAIGN_DUPLICATE') && 
                                <MenuItem onClick={() => handleCopyCampaign(row.campaignId, row.name)}>
                                    <span className='text-muted font-normal'>Duplicate</span>
                                </MenuItem>
                    }
                                {checkEventPermission('CAMPAIGN_DOWNLOAD_REPORT') && moment(row.startOn).isBefore(moment()) && 
                                    <MenuItem onClick={() => handleDownloadReport(row.campaignId)}>
                                        <span  className='text-muted font-normal'>Download Report</span>
                                    </MenuItem>
                                }
                                <MenuItem onClick={() => handleAPIInfo(row.campaignId)}>
                                    <span className='text-muted font-normal'>API Info</span>
                                </MenuItem>
                                {checkEventPermission('CAMPAIGN_SEND_TEST_EMAIL') &&  row.isActive === true &&
                                    <MenuItem onClick={() => handleSendTestEmailModal(row.campaignId, row.templateId)} >
                                        <span className='text-muted font-normal'>Send Test Email</span>
                                    </MenuItem>
                                }
                                {checkEventPermission('CAMPAIGN_ACTIVATE_TEST_MODE') &&  row.isActive === false &&
                                    <MenuItem onClick={() => handleActivateTestModeModal(row.campaignId, row.name, row.isTestMode)} >
                                        <span className='text-muted font-normal'>{row.isTestMode === true ? "Deactivate Test Mode" : "Activate Test Mode"}</span>
                                    </MenuItem>
                                }
                                {checkEventPermission('CAMPAIGN_DELETE') && 
                                <BootstrapTooltip title={row.isCampaignInUse ? "Campaign is already in use" : moment(row.startOn).isBefore(moment()) ? "Campaign start date has passed" : ""} disableHoverListener={false}>
                                    <span> {/* Wrap in a span to ensure proper behavior when disabled */}
                                        <MenuItem
                                            onClick={() => handleDeleteTemplate(row.campaignId, row.name, row.isCampaignInUse)}
                                            disabled={row.isCampaignInUse || moment(row.startOn).isBefore(moment())} // Disable based on conditions
                                        >
                                            <span
                                                style={{
                                                    
                                                    color: row.isCampaignInUse || moment(row.startOn).isBefore(moment()) ? '#aaa' : '#F13139', // Greyed out if disabled
                                                    cursor: row.isCampaignInUse || moment(row.startOn).isBefore(moment()) ? 'not-allowed' : 'pointer'
                                                }}
                                            >
                                                Delete
                                            </span>
                                        </MenuItem>
                                    </span>
                                </BootstrapTooltip>
            }
                            </Menu>
                        </div>

                    </div>
                )
            },
            //   width: '10%',
            sortable: false
        },

    ]

    const DeleteModal = (): JSX.Element => {
        if (isCampaignInUse) {
            return (
                <BootstrapDialog
                    onClose={handleDeleteTemplateClose}
                    aria-labelledby="customized-dialog-title"
                    open={showDeleteTemplateModal}
                    PaperProps={{
                        sx: {
                            width: '550px',
                            height: '200px'
                        },
                    }}
                >
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Delete Campaign
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleDeleteTemplateClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>The campaign <span className='font-semibold'>{templateInfoData?.templateName}</span> is currently in use</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Close</OutlineButton>
                    </DialogActions>
                </BootstrapDialog>
            );
        }

        return (
            <BootstrapDialog
                onClose={handleDeleteTemplateClose}
                aria-labelledby="customized-dialog-title"
                open={showDeleteTemplateModal}
                PaperProps={{
                    sx: {
                        width: '550px',
                        height: '200px'
                    },
                }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    Delete Campaign
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleDeleteTemplateClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <HugeiconsIcon
                        icon={MultiplicationSignStrokeStandard}
                        size={24}
                        color="currentcolor"
                        strokeWidth={0.5}
                    />
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_CAMPAIGN} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleDeleteTemplateClose} width='100px'>Cancel</OutlineButton>
                    <GradientButton type='button' color='red' onClick={handleDeleteTemplateConfirm} width='100px'>
                        {!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </GradientButton>
                </DialogActions>
            </BootstrapDialog>
        );
    };

    const StatusUpdateModal = (): JSX.Element => {
        if (isCampaignInUse) {
            return (
                <BootstrapDialog
                    onClose={handleupdatestatusClose}
                    aria-labelledby="customized-dialog-title"
                    open={showDeactivateTemplateModal}
                    PaperProps={{ sx: { width: '550px', height: '200px' } }}
                >
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        {templateInfoData?.newStatus === true ? "Deactivate Campaign" : "Activate Campaign"}
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleupdatestatusClose}
                        sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>The campaign <span className='font-semibold'>{templateInfoData?.templateName}</span> is currently in use</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleupdatestatusClose} width='100px'>Close</OutlineButton>
                    </DialogActions>
                </BootstrapDialog>
            );
        }

        return (
            <BootstrapDialog
                onClose={handleupdatestatusClose}
                aria-labelledby="customized-dialog-title"
                open={showDeactivateTemplateModal}
                PaperProps={{ sx: { width: '550px', height: '200px' } }}
            >
                <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                    {templateInfoData?.newStatus === true ? "Deactivate Campaign" : "Activate Campaign"}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleupdatestatusClose}
                    sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                >
                    <HugeiconsIcon
                        icon={MultiplicationSignStrokeStandard}
                        size={24}
                        color="currentcolor"
                        strokeWidth={0.5}
                    />
                </IconButton>
                <DialogContent>
                    <p className='text-14 text-muted'>{ARE_YOU_SURE} {templateInfoData?.newStatus === true ? "deactivate" : "activate"} the campaign <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                </DialogContent>
                <DialogActions sx={{ background: '#F9F9F9' }}>
                    <OutlineButton color='gray' onClick={handleupdatestatusClose} width='130px'>Cancel</OutlineButton>
                    <GradientButton
                        type='button'
                        color='red'
                        onClick={handleUpdateStatusConfirm}
                        width='130px'
                    >
                        {!isModalSaveLoading ? (templateInfoData?.newStatus === true ? "Deactivate" : "Activate") : (
                            <span className="loading loading-spinner loading-xs text-white"></span>
                        )}
                    </GradientButton>
                </DialogActions>
            </BootstrapDialog>
        );
    };

    const handleSendTestEmailModal = (id: number, templateId: number): void => {
        setTestEmailModalOpen(true);
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
        setTemplateId(templateId);
        setCampaignId(id);
    }
    console.log(isCampaignInUse);
    return (
        <>
            <h2 className="text-2xl font-semibold text-title">Campaign Overview</h2>
            <div className="mt-[20px] mb-[20px] live-outreach-container">
                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item xs={6} md={6} lg={6} xl={4} order={{ xs: 1, md: 1, lg: 1, xl: 1 }}>
                        <div className='flex items-center input-search-container'>
                            <div className="mr-[0px] w-[640px]">
                                <div className="form-control">
                                    <input type="text" placeholder="Search campaign" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
                                </div>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12} xl={6} order={{ xs: 2, md: 2, lg: 2, xl: 1 }} sx={{ display: 'flex', alignItems: 'center' }} className='select-client'>
                        <div className='mr-[20px] status-autocomplete'>
                            <FormControl fullWidth sx={{ width: '200px' }}>
                                <Autocomplete
                                    options={brands}
                                    getOptionLabel={(option: any) => option.brandName}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={(_, selectedBrand) => handleSearchByBrand(selectedBrand)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Brand"
                                            placeholder="Select Brand"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}
                                //disableClearable
                                />
                            </FormControl>
                        </div>
                        <div className='mr-[20px] status-autocomplete'>
                            <FormControl fullWidth sx={{ width: '200px' }}>
                                <Autocomplete
                                    options={groups}
                                    getOptionLabel={(option: any) => option.groupName}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    isOptionEqualToValue={(option, value) => option.id === value}
                                    onChange={(_, selectedGroup) => handleSearchByGroup(selectedGroup)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Group"
                                            placeholder="Select Group"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}
                                //disableClearable
                                />
                            </FormControl>
                        </div>
                        <div className='mr-[20px] status-autocomplete'>
                            <FormControl fullWidth sx={{ width: '200px' }}>
                                <Autocomplete
                                    options={options}
                                    getOptionLabel={(option) => option.label}
                                    popupIcon={
                                        <HugeiconsIcon
                                            icon={ArrowDown01Icon}
                                            size={18}
                                            color="#3A3A3A"
                                            strokeWidth={0.2}

                                        />
                                    }
                                    onChange={(event, newValue) => handleTemplateValue(newValue)}
                                    //disableClearable
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Status"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '40px',
                                                    height: '40px',
                                                    width: '200px', // Increased width
                                                },
                                            }}
                                        />
                                    )}
                                    sx={{
                                        '& .MuiAutocomplete-clearIndicator': {
                                            marginRight: '-12px'
                                        },
                                        '& .MuiAutocomplete-input': {
                                            width: '70%'
                                        }
                                    }}

                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6} xl={2} order={{ xs: 1, md: 1, lg: 1, xl: 1 }} className='bulk-action'>
                        {checkEventPermission('CAMPAIGN_ADD') && 
                        <div className="justify-end flex">
                            <GradientButton color='red' onClick={handleAddCampaignClick}>
                                <span style={{
                                    width: "20px",
                                    height: "20px",
                                    background: "#fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: "50px",
                                    marginRight: "5px"
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                                        <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                                        <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                                    </svg>
                                </span>
                                New Campaign
                            </GradientButton>
                        </div>
                        }
                    </Grid>
                </Grid>
            </div>

            <div className='data-table-container campaign-table campaign-table-container mb-10'>
                <CustomDataTable
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    columns={columns}
                    data={campaignSearchData}
                    pagination
                    //   selectableRows
                    progressPending={loading}
                />


                <MUIModal title='API Information' openModal={openAPIInformationModal} closeModal={handleCloseAPIInfoModal} width={'50%'} >
                    <APIInformation closeModal={handleCloseAPIInfoModal} refreshPage={handleRefreshPage} id={campaignId} />
                </MUIModal>


                <BootstrapDialog onClose={closeActivateTestModeModal} aria-labelledby="customized-dialog-title" open={showActivateTestModal} PaperProps={{ sx: { width: '650px', height: 'auto' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        {isTestMode === true ? "Deactivate Test Mode" : "Activate Test Mode"}
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={closeActivateTestModeModal} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE} {isTestMode === false ? ACTIVATE_TEST_MODE : DEACTIVATE_TEST_MODE} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                        {
                            isTestMode === false && (
                                <React.Fragment>
                                    <TextField
                                        fullWidth
                                        // multiline
                                        sx={{ pb: 2, marginTop: '10px' }}
                                        // rows={3} // Set to exactly 3 rows
                                        value={emails}
                                        onChange={(e) => {
                                            setEmails(e.target.value);
                                            setError('');
                                        }}
                                        placeholder="Please enter recipient email address"
                                        error={Boolean(error)}
                                    />
                                    {error !== "" && (
                                        <div className="flex absolute text-primary ml-1 mb-2 text-md font-normal" style={{ marginTop: '-7px' }}>
                                            <img src="/assets/images/attention.svg" alt="Attention" width={12} height={12} className="mr-1" />
                                            {error.length > 50 ? `${error.substring(0, 50)}...` : error}
                                        </div>
                                    )}
                                </React.Fragment>
                            )
                        }
                        
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={closeActivateTestModeModal} width='100px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleActivateTestModeConfirm} width='100px'>{!isModalSaveLoading ? `${isTestMode === false ? 'Activate' : 'Deactivate'}` : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>

                <BootstrapDialog onClose={handleCopyCampaignClose} aria-labelledby="customized-dialog-title" open={showCopyCampaignModal} PaperProps={{ sx: { width: '550px', height: '200px' }, }}>
                    <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                        Duplicate Campaign
                    </DialogTitle>
                    <IconButton aria-label="close" onClick={handleCopyCampaignClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <HugeiconsIcon
                            icon={MultiplicationSignStrokeStandard}
                            size={24}
                            color="currentcolor"
                            strokeWidth={0.5}
                        />
                    </IconButton>
                    <DialogContent>
                        <p className='text-14 text-muted'>{ARE_YOU_SURE} {COPY_CAMPAIGN} <span className='font-semibold'>{templateInfoData?.templateName}</span>?</p>
                    </DialogContent>
                    <DialogActions sx={{ background: '#F9F9F9' }}>
                        <OutlineButton color='gray' onClick={handleCopyCampaignClose} width='100px'>Cancel</OutlineButton>
                        <GradientButton type='button' color='red' onClick={handleCopyCampaignConfirm} width='100px'>{!isModalSaveLoading ? 'Duplicate' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                    </DialogActions>
                </BootstrapDialog>

                {showDeleteTemplateModal && <DeleteModal />}
                {showDeactivateTemplateModal && <StatusUpdateModal />}
            </div>
            <TemplatePreview
                isOpen={isPreviewModalOpen}
                onClose={() => setIsPreviewModalOpen(false)}
                content={previewContent}
            />
            <SendTestEmail open={testEmailModalOpen} onClose={() => setTestEmailModalOpen(false)} Type={"Campaign"} TypeId={campaignId} TemplateId={templateId} />

        </>
    );
}

export default CampaignList